<template>
  <div>
    <training-toolbar v-if="userInfo"/>
    <div class="card mx-md-5 mt-3 mb-3 bg-form">
      <card-header
        :title="$t('training-view.title')"
        :iconName="'folder2-open'"
      />
      <b-card-body>
        <b-alert variant="success" v-model="popSuccessAlert" dismissible> {{ this.successMessage }} </b-alert>
        <b-alert v-for="error in errors" :key="error.message" v-model="popAlert"  variant="danger" dismissible>
          {{ error.message }}
        </b-alert>

        <template v-if="this.activity != null">
          <training-tabs :activity="activity" v-on:error:api.capture="handleError" 
            @success="showSuccess" @leaders-changed="leadersChanged" @download-report="downloadReport"/>
        </template>
      </b-card-body>
    </div>
  </div>
</template>

<script>
import CardHeader from '../../components/common/cardHeader.vue'
import trainingService from '../../services/training.service';
import { handleApiError } from '../../services/error.service';
import TrainingTabs from '../../components/training/trainingTabs.vue';
import TrainingToolbar from '../../components/common/trainingToolbar.vue';
import {hasRole} from "esep/src/services/utils";
import {roles, routes} from "esep/src/services/routing.service";


export default {
  components: {
    CardHeader,
    TrainingTabs,
    TrainingToolbar
  },
  mounted() {
    trainingService.getUserInfo(this.username).then(
      (response) => {
        this.userInfo = response.data;
        if (!hasRole(this.userInfo,roles.training.trainings)){
          location.replace(routes.nothing);
        }
        this.$store.state.userInfo = this.userInfo;
      },
      (error) => {
        let errorMessage = handleApiError(error);
        this.handleError(errorMessage);
      }
    );
    this.getActivityById();
  },
  data() {
    return {
      userInfo: null,
      popSuccessAlert: false,
      popAlert: false,
      successMessage: null,
      errors: null,
      activity: null
    }
  }, 
  methods: {
    handleError(errors) {
      errors.forEach(error => {
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length>0;
      if(errors?.length>0) {
        window.scrollTo(0,0);
      }
    },
    showSuccess(successMessage) {
      this.successMessage = successMessage;
      this.popSuccessAlert = true;
      window.scrollTo(0,0);
      this.getActivityById();
    },
    getActivityById() {
      trainingService.getActivityById(this.$route.params.id).then(
        (response) => {
          this.$log.debug(response.data);
          this.activity = response.data;      
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      )
    },
    leadersChanged(leaders) {
      this.activity.leaders = leaders;
      this.$log.debug('after leaders changed');
      this.$log.debug(this.activity);
    },
    downloadReport() {
      const fileDownload = require('js-file-download');
      trainingService.downloadActivityWorkbook(this.activity).then(
        (response) => {
          fileDownload(response.data, 'workbook.xls');
        },
        (error) => {
          this.handleError(handleApiError(error));
        }
      )
    }
  }
}
</script>